
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
import api from '@/api/';
import {getCloudTreeData, getRegionalRcountriesData, getYmsSiteData} from "@/utils/common";

export default {
  data() {
    return {
      shipmentTagModel: [],
      shipmentPlatformModel: '',
      productCategoryListName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000185'),
      siteIdName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000186'),
      saleAccountName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000187'),
      shipmentPlatformSite: '',
      productGoodsIds: '',
      smShippingMethodList: [],
      shipmentCheckBoxModel: [],
      smShippingSearch: [],
      currencyList: [],
      warehouseList: [],
      placeOfShipmentList: [],
      productTagList: [],
      shippingWarehouseList: [],
      ymsProductCategoryList: [],
      customerGradeList: [],
      shippingParmas: [],
      value2: [],
      shopSkuModel: null,
      totalPrices: {
        currency: null,
        beginValue: null,
        endValue: null,
      },
      shopSku: {
        start: '',
        end: ''
      },
      greaterSign: [
        {label: '≥', value: '0'},
        {label: '>', value: '1'},
        {label: '=', value: '2'}
      ],
      LessSign: [
        {label: '<', value: '0'},
        {label: '≤', value: '1'}
      ],
      andOr: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000188'), value: '0'},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000189'), value: '1'}
      ],
      isBy: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000190'), value: '0'},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000191'), value: '1'}
      ],
      platform: [
        {
          platformId: 'all',
          value: '',
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
        }
      ],
      shipmentPlatformList: [],
      disSites: [],
      sitesList: [],
      platformAccountList: [],
      sitesArr: [],
      accountSite: [],
      countryData: [],
      ruleCountryData: [],
      countryCodes: [],
      shipmentPlatformSiteList: [],
      shipmentSearchValue: null,
      postcodeArea: '',
      countryCodesName: '',
      shippingMethodName: '',
      sourceText: {
        platformIds: [],
        siteIds: [],
        saleAccountIds: []
      },
      source: {
        platformIds: [],
        siteIds: [],
        saleAccountIds: []
      },
      hasSite: false,
      postcodeArr: [
        {
          postcode1: '',
          postcode2: ''
        }
      ],
      amountRange: {
        usdUpper: 0,
        usdFloor: 0,
        audUpper: 0,
        audFloor: 0,
        eurUpper: 0,
        eurFloor: 0,
        gbpUpper: 0,
        gbpFloor: 0,
        cnyFloor: 0,
        cnyUpper: 0
      },
      accountIds: [],
      normalizerData(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.zoneCode,
          label: node.title,
          children: node.children
        };
      },
    };
  },
  methods: {
    /**
     * @date: 2021/10/19 16:14
     * @param obj  object [id  values]
     */
    OnRuleTempAbnormalConfirm(obj) {
      this.rules.forEach(i => {
        if (i.id === obj.id) {
          i.values = Object.assign(i.values, obj.values);
        }
      });
    },
    changeDisPlatformId(ruleItem) {
      /**
       * 现在是只有一个ebay
       * */
      let v = this;
      if (ruleItem.values['platformIds'] && ruleItem.values['platformIds'].length) {
        this.getPlatformSite(ruleItem.values['platformIds'][0]);
        this.getPlatformStoreData(ruleItem.values['platformIds']);
      } else {
        v.rules.forEach(i => {
          if (i.id === ruleItem.id) {
            i.values['siteIds'] = null;
            i.values['saleAccountIds'] = null;
          }
        });
      }
    },
    getPlatformSite(platformId) {
      let v = this;
      return new Promise(resolve => {
        v.axios.get(api.get_salesPlatformSite_query + '?platformId=' + platformId).then(response => {
          if (response.data.code === 0) {
            v.disSites = response.data.datas;
            resolve();
          }
        });
      });
    },
    getPlatformStoreData(platformId) {
      let v = this;
      return new Promise(resolve => {
        v.axios.post(api.post_ymsPlatformAccount_queryYmsPlatformAccountList, {
          platformIds: platformId || ['ebay']
        }).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data && data.length > 0) {
              v.platformAccountList = data;
            } else {
              v.platformAccountList = [];
            }
            resolve(response.data.datas);
          }
        });
      });
      
    },
    getAccountApi(value, selectedData) {
      let v = this;
      v.carrierAccount = [];
      if (value.length === 0) return false;
      v.shippingMethodModel = [];
      v.shippingAccountModel = [];
      // v.getCarrierBaseSettingApi(value[1]); ;
      if (value[1] !== null) {
        v.shippingParmas.push({
          carrierId: value[0],
          shippingId: value[1],
          name: selectedData[1].__label
        });
      }
    },
    handleClose(index) {
      this.shippingParmas.splice(index, 1);
    },
    loadDataApi(item, callback) {
      item.loading = true;
      let v = this;
      v.axios.get(api.get_enableShippingMethods + '?carrierId=' + item.value).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          let pos = [];
          for (let i = 0; i < data.length; i++) {
            pos.push({
              value: data[i].shippingMethodId,
              label: data[i].carrierShippingMethodName
            });
            if (i === data.length - 1) {
              item.children = pos;
              item.loading = false;
              callback();
            }
          }
          if (data.length === 0) {
            item.children = pos;
            item.loading = false;
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000142'));
            callback();
          }
        } else {
          item.loading = false;
          item.children = [];
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000192'));
        }
      }).catch(() => {
        item.loading = false;
        item.children = [];
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000192'));
      });
    },
    setTagValue(checkboxArr) { // 运输类型产生tag
      let v = this;
      let arr = [];
      for (let i = 0; i < checkboxArr.length; i++) {
        if (checkboxArr[i].split(':').length > 3) {
          // 有站点
          let prefix = checkboxArr[i].split(':')[0];
          let item = checkboxArr[i].split(':')[3];
          for (let t = 0; t < v.smShippingMethodList.length; t++) {
            let subItem = v.smShippingMethodList[t];
            if (item === subItem.shippingMethodName && !v.shipmentTagModel.includes(prefix + ':' + subItem.siteName + ':' + subItem.shippingMethodDescription)) {
              arr.push(prefix + ':' + subItem.siteName + ':' + subItem.shippingMethodDescription);
            }
            if (i === checkboxArr.length - 1 && t === v.smShippingMethodList.length - 1) {
              v.shipmentTagModel = [...v.shipmentTagModel, ...arr];
            }
          }
        } else {
          let prefix = checkboxArr[i].split(':')[0];
          let item = checkboxArr[i].split(':')[1].split(':')[0];
          for (let t = 0; t < v.smShippingMethodList.length; t++) {
            let subItem = v.smShippingMethodList[t];
            if (item === subItem.shippingMethodName && !v.shipmentTagModel.includes(prefix + ':' + subItem.shippingMethodDescription)) {
              arr.push(prefix + ':' + subItem.shippingMethodDescription);
            }
            if (i === checkboxArr.length - 1 && t === v.smShippingMethodList.length - 1) {
              v.shipmentTagModel = [...v.shipmentTagModel, ...arr];
            }
          }
        }
      }
    },
    saveShopifyLogisticsMode() {
      // shopify 新增运输类型
      let v = this;
      if (v.shippingMethodName === '') {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000193'));
        return;
      }
      v.axios.post(api.add_merchantShippingMethod, {
        'platformId': v.shipmentPlatformModel,
        'shippingMethodName': v.shippingMethodName
      }).then(res => {
        if (res.data.code === 0) {
          v.shippingMethodName = '';
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000194'));
          v.shipmentSearch();
        } else {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000195'));
        }
      });
    },
    deleteShipMethod(shipId, index) {
      let v = this;
      if (shipId === undefined) {
        v.smShippingMethodList.splice(index, 1);
        v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
        return;
      }
      v.axios.delete(api.delete_merchantShippingMethod + shipId).then(res => {
        if (res.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
          v.shipmentSearch();
        } else {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000196'));
        }
      });
    },
    changePlatformId(ruleItem) {
      this.changePlatformId(ruleItem.values['platformIds']);
      let siteIds = ruleItem.values['siteIds'] || [];
      let saleAccountIds = ruleItem.values['saleAccountIds'] || [];
      let allSiteId = this.sitesList.map(i => i.siteIds);
      let allAccountList = this.platformAccountList.map(i => i.saleAccountId);
      for (let i = siteIds.length; i >= 0; i--) {
        if (!allSiteId.includes(siteIds[i])) {
          siteIds.splice(i, 1);
        }
      }
      for (let i = saleAccountIds.length; i >= 0; i--) {
        if (!allAccountList.includes(siteIds[i])) {
          saleAccountIds.splice(i, 1);
        }
      }
      this.rules.forEach((rule, index) => {
        if (rule.id === ruleItem.id) {
          this.$set(this.rules[index].values, 'siteIds', siteIds);
          this.$set(this.rules[index].values, 'saleAccountIds', saleAccountIds);
        }
      });
    },
    getShimentSites(platformArr) {
      let v = this;
      let sitesArr = [];
      let accountSite = [];
      v.shipmentPlatformList.forEach((n, i) => {
        platformArr.forEach((m, t) => {
          if (n.platformId === m) {
            sitesArr = sitesArr.concat(n.sites);
            accountSite = accountSite.concat(n.saleAccounts);
          }
        });
      });
      v.sitesList = sitesArr;
      v.platformAccountList = accountSite;
    },
    getSmShippingMethod(platformId, siteId, siteName) {
      let v = this;
      let params = '?platformId=' + platformId;
      if (siteId) {
        params = params + '&siteId=' + siteId;
      }
      params = params + '&search=' + v.shipmentSearchValue;
      return new Promise(resolve => {
        v.axios.get(api.get_queryShippingMethod + params).then(response => {
          if (response.data.code === 0) {
            v.smShippingSearch = response.data.datas;
            v.smShippingMethodList = response.data.datas.map(i => {
              if (siteId) {
                i.siteId = siteId;
                i.siteName = siteName;
              }
              return i;
            });
            resolve();
          }
        });
      });
    },
    shipmentSearch() {
      let v = this;
      v.smShippingMethodList = v.smShippingSearch.filter(item => {
        return item.shippingMethodDescription.toLowerCase().indexOf(v.shipmentSearchValue.toLowerCase()) > -1;
      });
      let siteName = null;
      if (v.shipmentPlatformSite) {
        let list = v.shipmentPlatformSiteList.filter(i => i.siteId === v.shipmentPlatformSite) || [];
        if (list.length > 0) {
          siteName = list[0].cnName;
        }
      }
      v.getSmShippingMethod(v.shipmentPlatformModel, v.shipmentPlatformSite, siteName);
    },
    delTag(index) { // 删除标签
      let v = this;
      v.shipmentCheckBoxModel.splice(index, 1);
      v.shipmentTagModel.splice(index, 1);
    },
    tagColor(item) {
      item = item.split(':')[0];
      switch (item) {
        case 'ebay' :
          return 'blue';
        case 'aliexpress' :
          return 'red';
        default :
          return 'yellow';
      }
    },
    setNumber(type) {
      let currencyList = [
        {type: 1, floorKey: 'usdFloor', upperKey: 'usdUpper'},
        {type: 2, floorKey: 'eurFloor', upperKey: 'eurUpper'},
        {type: 3, floorKey: 'gbpFloor', upperKey: 'gbpUpper'},
        {type: 4, floorKey: 'audFloor', upperKey: 'audUpper'},
        {type: 5, floorKey: 'cnyFloor', upperKey: 'cnyUpper'}
      ];
      currencyList.map((item) => {
        if (type === item.type) {
          if (this.amountRange[item.floorKey] > this.amountRange[item.upperKey]) {
            this.amountRange[item.upperKey] = this.amountRange[item.floorKey];
          }
        }
      });
    },
    setSite(val) {
      let siteName = this.shipmentPlatformSiteList.filter(i => i.siteId === val)[0].cnName;
      let v = this;
      this.getSmShippingMethod(this.shipmentPlatformModel, val, siteName).then(() => {
        if (v.shipmentCheckBoxModel && v.shipmentCheckBoxModel.length > 0) {
          let data = v.shipmentCheckBoxModel.map(i => i);
          v.shipmentCheckBoxModel = [];
          v.shipmentCheckBoxModel = data;
        }
      });
    },
    getSite(val) { // 获取站点
      let v = this;
      v.shipmentPlatformSiteList = [];
      v.shipmentPlatformSite = '';
      v.shipmentSearchValue = '';
      for (let i = 0; i < v.shipmentPlatformList.length; i++) {
        let item = v.shipmentPlatformList[i];
        if (item.platformId === val && item.sites && item.sites.length > 0) {
          v.hasSite = true;
          v.getSmShippingMethod(val, item.sites[0].siteId, item.sites[0].cnName);
          v.$nextTick(function () {
            v.shipmentPlatformSiteList = item.sites;
            v.shipmentPlatformSite = item.sites[0].siteId;
          });
        } else if (item.platformId === val && (!item.sites || item.sites.length === 0)) {
          v.hasSite = false;
          v.shipmentPlatformSiteList = [];
          v.getSmShippingMethod(val);
        }
      }
    },
    scopePlatformChange() {
      let v = this;
      if (v.pageType === 'distributor') {
        v.getPlatformStoreData(v.platformIds).then(() => {
          if (v.accountIds && v.accountIds.length) {
            let ids = v.platformAccountList.map(i => i.ymsPlatformAccountId);
            for (let i = v.accountIds.length - 1; i >= 0; i--) {
              if (!ids.includes(v.accountIds[i])) v.accountIds.splice(i, 1);
            }
          }
        });
      }
    },
    // 删除收货地址街道
    streetsRemove(index, sIndex) {
      this.rules[index].values['streets'].splice(sIndex, 1);
    },
    // 新增收货地址街道
    streetsAdd(index) {
      if (!this.rules[index].values['streets']) {
        this.rules[index].values['streets'] = [];
      }
      this.rules[index].values['streets'].push({
        value: ''
      });
    },
    // 删除订单在电商平台后台发货仓
    warehouseNamesRemove(index, sIndex) {
      this.rules[index].values['warehouseNames'].splice(sIndex, 1);
    },
    // 新增订单在电商平台后台发货仓
    warehouseNamesAdd(index) {
      if (!this.rules[index].values['warehouseNames']) {
        this.rules[index].values['warehouseNames'] = [];
      }
      this.rules[index].values['warehouseNames'].push({
        value: ''
      });
    },
    
    // getTreeData(val, id) {
    //   let v = this;
    //   let nodesArr = v.$refs['treeSelectRef1'][0].getCheckedNodes();
    //   let arr = [];
    //   nodesArr.forEach((n, i) => {
    //     // eslint-disable-next-line no-prototype-builtins
    //     if (n.hasOwnProperty('zoneCode')) {
    //       arr.push(n.zoneCode);
    //     }
    //   });
    //   v.rules.forEach(i => {
    //     if (i.id === id) {
    //       i.values['countryCodes'] = arr;
    //     }
    //   });
    // },
    // 选择国家
    selectRuleCountry(data, obj, id) {
      let v = this;
      let newList = [];
      
      function treeToList(tree, result = []) {
        tree.forEach(node => {
          result.push(node);
          node.children && treeToList(node.children, result);
        });
        return result;
      }
      
      function handleData(list) {
        let countryList = treeToList(list);
        let arr = [];
        countryList.forEach((n, i) => {
          if (n.hasOwnProperty('zoneCode') && n.zoneCode !== 'null') {
            arr.push(n.zoneCode);
          }
        });
        return arr;
      }
      
      if (v.ruleCountryData && v.ruleCountryData.length > 0) {
        if (data.length > 0) {
          // 全部国家
          if (data.includes('null')) {
            newList = handleData(v.ruleCountryData);
          } else {
            let list = [];
            let childrenList = [];
            let countryList = treeToList(v.ruleCountryData);
            countryList.map((item) => {
              if (data.includes(item.zoneCode)) {
                if (item.children) {
                  childrenList.push(item);
                } else {
                  list.push(item.zoneCode);
                }
              }
            });
            newList = [...list, ...handleData(childrenList)];
          }
        }
        v.rules.forEach((item, index) => {
          if (item.id === id) {
            if (newList.length > 0) {
              setTimeout(() => {
                v.$set(v.rules[index].values, 'countryCodes', newList);
              }, 300);
            }
          }
        });
        v.$forceUpdate();
      }
    },
    shipmentIO(type, id) {
      let v = this;
      if (type === 'reset') {
        v.shipmentCheckBoxModel = [];
        v.shipmentTagModel = [];
      } else {
        v.rules.forEach(i => {
          if (i.id === id) {
            if (type === 'input') {
              let shippingArr = [];
              for (let j = 0; j < v.shipmentCheckBoxModel.length; j++) {
                let shipItem = v.shipmentCheckBoxModel[j];
                let data = shipItem.split(':');
                let obj = null;
                if (data.length > 3) {
                  // 有站点
                  obj = {
                    'platformId': data[0],
                    'siteId': data[1],
                    'siteName': data[2],
                    'shipmentName': data[3],
                    'shipmentDesc': data[4]
                  };
                } else {
                  obj = {
                    'platformId': data[0],
                    'siteId': null,
                    'siteName': null,
                    'shipmentName': data[1],
                    'shipmentDesc': data[2]
                  };
                }
                shippingArr.push({
                  value: JSON.stringify(obj)
                });
                if (j === v.shipmentCheckBoxModel.length - 1) {
                  i.values['shipmentTypes'] = shippingArr;
                }
              }
            } else if (type === 'output') {
              let arr = [];
              let tagArr = [];
              i.values.shipmentTypes.forEach((obj, i) => {
                let n = JSON.parse(obj);
                if (n.siteId) {
                  arr.push(n.platformId + ':' + n.siteId + ':' + n.siteName + ':' + n.shipmentName + ':' + n.shipmentDesc);
                  tagArr.push(n.platformId + ':' + n.siteName + ':' + n.shipmentDesc);
                } else {
                  arr.push(n.platformId + ':' + n.shipmentName + ':' + n.shipmentDesc);
                  tagArr.push(n.platformId + ':' + n.shipmentDesc);
                }
              });
              v.shipmentCheckBoxModel = arr;
              v.shipmentTagModel = tagArr;
            }
            
          }
        });
      }
    },
    shippingIO(type, id) {
      let v = this;
      if (type === 'reset') {
        v.shippingParmas = [];
      } else {
        v.rules.forEach(i => {
          if (i.id === id) {
            if (type === 'input') {
              i.values['shippingMethodIds'] = v.shippingParmas.map(i => {
                return {
                  value: i.carrierId + ',' + i.shippingId + ',' + i.name
                };
              });
            } else if (type === 'output') {
              if (i.values['shippingMethodIds']) {
                v.shippingParmas = i.values['shippingMethodIds'].map(i => {
                  return {
                    carrierId: i.split(',')[0],
                    shippingId: i.split(',')[1],
                    name: i.split(',')[2]
                  };
                });
              }
              
            }
          }
        });
      }
    },
    disOrderSourceIO(type, id) {
      let v = this;
      if (type === 'reset') {
        this.disSites = [];
        this.platformAccountList = [];
        this.siteIdName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000186');
        this.saleAccountName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000187');
      } else {
        v.rules.forEach(i => {
          if (i.id === id) {
            if (type === 'input') {
            
            } else if (type === 'output') {
              
              if (i.values['platformIds'] && i.values['platformIds'].length) {
                this.getPlatformSite(i.values['platformIds'][0]).then(() => {
                  this.siteIdName = this.setSiteIdName();
                });
                this.getPlatformStoreData(i.values['platformIds']).then(() => {
                  this.saleAccountName = this.setSaleAccountName();
                });
              }
            }
          }
        });
      }
    },
    tempIO(type, id) {
      let v = this;
      if (type === 'reset') {
      } else {
        v.rules.forEach(i => {
          if (i.id === id) {
            if (type === 'input') {
            } else if (type === 'output') {
            }
          }
        });
      }
    },
    streetsIO(type, id) {
      let v = this;
      if (type === 'reset') {
      } else {
        v.rules.forEach(i => {
          if (i.id === id) {
            if (type === 'input') {
            } else if (type === 'output') {
              if (i.values['streets'].length) {
                i.values['streets'] = i.values['streets'].map(i => {
                  return {
                    value: i
                  };
                });
              }
            }
          }
        });
      }
    },
    warehouseNamesIO(type, id) {
      let v = this;
      if (type === 'reset') {}
      else {
        v.rules.forEach(i => {
          if (i.id === id) {
            if (type === 'input') {
            } else if (type === 'output') {
              if (i.values['warehouseNames'].length) {
                i.values['warehouseNames'] = i.values['warehouseNames'].map(i => {
                  return {
                    value: i
                  };
                });
              }
            }
          }
        });
      }
    },
    productGoodsIO(type, id) {
      let v = this;
      if (type === 'reset') {
        v.productGoodsIds = [];
      } else {
        v.rules.forEach(i => {
          if (i.id === id) {
            if (type === 'input') {
              i.values['productGoodsIds'] = v.productGoodsIds.split(',');
            } else if (type === 'output') {
              if (i.values['productGoodsIds']) {
                v.productGoodsIds = i.values['productGoodsIds'].join(',');
              }
            }
          }
        });
      }
    },
    totalPricesIO(type, id) {
      let v = this;
      if (type === 'reset') {
        v.totalPrices = {
          currency: null,
          beginValue: null,
          endValue: null,
        };
      } else {
        v.rules.forEach(i => {
          if (i.id === id) {
            if (type === 'input') {
              i.values['totalPrices'] = v.totalPrices.currency + ',' + v.totalPrices.beginValue + ',' + v.totalPrices.endValue;
            } else if (type === 'output') {
              let value = i.values['totalPrices'].split(',');
              v.totalPrices.currency = value[0];
              v.totalPrices.beginValue = value[1];
              v.totalPrices.endValue = value[2];
            }
          }
        });
      }
    },
    amountRangeIO(type, id) {
      let v = this;
      if (type === 'reset') {
        v.amountRange = {
          usdUpper: 0,
          usdFloor: 0,
          audUpper: 0,
          audFloor: 0,
          eurUpper: 0,
          eurFloor: 0,
          gbpUpper: 0,
          gbpFloor: 0,
          cnyFloor: 0,
          cnyUpper: 0
        };
      } else {
        v.rules.forEach(i => {
          if (i.id === id) {
            if (type === 'input') {
              let mtItem = v.amountRange;
              i.values['totalPrices'] = [
                {value: 'usd,' + mtItem.usdFloor + ',' + mtItem.usdUpper},
                {value: 'aud,' + mtItem.audFloor + ',' + mtItem.audUpper},
                {value: 'eur,' + mtItem.eurFloor + ',' + mtItem.eurUpper},
                {value: 'gbp,' + mtItem.gbpFloor + ',' + mtItem.gbpUpper},
                {value: 'cny,' + mtItem.cnyFloor + ',' + mtItem.cnyUpper}
              ];
            } else if (type === 'output') {
              i.values['totalPrices'].forEach(childItem => {
                let totalPricesItem = childItem.split(',');
                let currencyTypeList = [
                  {type: 'usd', floorKey: 'usdFloor', upperKey: 'usdUpper'},
                  {type: 'aud', floorKey: 'eurFloor', upperKey: 'eurUpper'},
                  {type: 'eur', floorKey: 'gbpFloor', upperKey: 'gbpUpper'},
                  {type: 'gbp', floorKey: 'audFloor', upperKey: 'audUpper'},
                  {type: 'cny', floorKey: 'cnyFloor', upperKey: 'cnyUpper'}
                ];
                currencyTypeList.map((item) => {
                  if (totalPricesItem[0] === item.type) {
                    v.amountRange[item.upperKey] = Number(totalPricesItem[2]);
                    v.amountRange[item.floorKey] = Number(totalPricesItem[1]);
                  }
                });
              });
            }
          }
        });
      }
    },
    countryCodesAndPostCodeIO(type, id) {
      let v = this;
      if (type === 'reset') {
        v.countryCodesName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000197');
        v.postcodeArr = [
          {
            postcode1: '',
            postcode2: ''
          }
        ];
        v.postcodeArea = '';
      } else {
        v.rules.forEach(i => {
          if (i.id === id) {
            if (type === 'input') {
              let arr = [];
              if (i.values['postalCodeType'] === '0') {
                v.postcodeArr.forEach(i => {
                  if (i.postcode1 && i.postcode2) {
                    arr.push({
                      value: i.postcode1 + '-' + i.postcode2
                    });
                  }
                });
              } else {
                if (v.postcodeArea) {
                  arr = [
                    {
                      value: v.postcodeArea
                    }
                  ];
                }
              }
              i.values['buyerPostalCodes'] = arr;
            } else if (type === 'output') {
              
              if (i.values['postalCodeType'] === '0' && i.values['buyerPostalCodes']) {
                v.postcodeArr = [];
                i.values['buyerPostalCodes'].forEach(j => {
                  v.postcodeArr.push(
                    {
                      postcode1: j.split('-')[0],
                      postcode2: j.split('-')[1]
                    }
                  );
                });
              }
              if (i.values['postalCodeType'] === '1' && i.values['buyerPostalCodes']) {
                v.postcodeArea = i.values['buyerPostalCodes'][0];
              }
              if (i.values['countryCodes']) {
                let val = i.values['countryCodes'];
                v.treeArr = val;
                
                function treeToList(tree, result = []) {
                  tree.forEach(node => {
                    result.push(node);
                    node.children && treeToList(node.children, result);
                  });
                  return result;
                }
                
                let countryList = treeToList(v.ruleCountryData);
                let talg = countryList.length === val.length;
                v.countryCodes = talg ? ['null'] : val;
                getRegionalRcountriesData().then((data) => {
                  v.getCommonCountryName(data, val);
                  v.getCommonCountry(data, val).then(list => {
                    v.$nextTick(() => {
                      v.ruleCountryData = list;
                    });
                  });
                });
              }
            }
          }
        });
      }
      
    },
    shopSkuModelIO(type, id) {
      let v = this;
      if (type === 'reset') {
        v.shopSkuModel = null;
        v.shopSku = {
          start: '',
          end: ''
        };
      } else {
        v.rules.forEach(i => {
          if (i.id === id) {
            if (type === 'input') {
              if (v.shopSkuModel === 0) {
                i.values['start'] = v.shopSku.start;
                i.values['end'] = null;
              } else {
                i.values['start'] = null;
                i.values['end'] = v.shopSku.end;
              }
            } else if (type === 'output') {
              v.shopSku.start = i.values['start'];
              v.shopSku.end = i.values['end'];
              v.shopSkuModel = v.shopSku.end ? 1 : 0;
            }
          }
        });
      }
    },
    productCategoryIO(type, id, val) {
      let v = this;
      if (type === 'reset') {
        v.productCategoryListName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000198');
      } else {
        v.rules.forEach(i => {
          if (i.id === id) {
            if (type === 'output') {
              v.productCategoryListName = '';
              let arr = [];
              if (i.values['productCategories']) {
                if (v.ymsProductCategoryList.length > 0) {
                  let list = flattenList(v.ymsProductCategoryList);
                  handleData(list);
                } else {
                  setTimeout(() => {
                    let url = this.system === 'yms' ? api.post_ymsProductCategory_queryAll : api.post_ymsProductCategory_api_queryAll;
                    getYmsSiteData().then((list) => {
                      let newList = list.filter((item) => {
                        return item.merchantType === 'YMS';
                      });
                      if (newList.length > 0) {
                        let ymsSiteId = newList[0].ymsSiteId;
                        getCloudTreeData(url, val, null, ymsSiteId, {time: new Date().getTime()}).then((data) => {
                          handleData(data);
                        });
                      }
                    });
                  }, 800);
                }
                
                function handleData(data) {
                  data.forEach(j => {
                    i.values['productCategories'].forEach(bItem => {
                      if (j.ymsProductCategoryId === bItem) {
                        let name = val === 'tile' ? j.title : j.name;
                        arr.push(name);
                      }
                    });
                  });
                  if (arr.length === 0) {
                    v.productCategoryListName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000198');
                  } else {
                    v.productCategoryListName = arr.join('、');
                  }
                }
                
                function flattenList(list) {
                  const result = [];
                  const loop = (arr) => {
                    (arr || []).forEach(item => {
                      const newItem = {...item};
                      delete newItem.children;
                      result.push(newItem);
                      if (Array.isArray(item.children) && item.children.length > 0) {
                        loop(item.children);
                      }
                    });
                  };
                  
                  loop(list);
                  return result;
                }
              }
            }
          }
        });
      }
    },
    getPostCodeType(value) {
      let v = this;
      v.postcodeOne = '';
      v.postcodeTwo = '';
      v.postcodeArea = '';
      v.postcodeArr = [
        {
          postcode1: '',
          postcode2: ''
        }
      ];
    },
    // 增加邮编
    addPostcodeFn() {
      let canAdd = true;
      this.postcodeArr.forEach(item => {
        if (item.postcode1 === '' || item.postcode2 === '') {
          canAdd = false;
        }
      });
      if (!canAdd) {
        this.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000199'));
        return false;
      }
      let obj = {
        postcode1: '',
        postcode2: ''
      };
      this.postcodeArr.push(obj);
    }, // 删除邮编
    orderStrRemove(index, id) {
      this.rules.forEach(i => {
        if (i.id === id) {
          i.values['containsStr'].splice(index, 1);
        }
      });
    },
    orderStrAdd(id) {
      this.rules.forEach(i => {
        if (i.id === id) {
          if (!i.values['containsStr']) {
            i.values['containsStr'] = [];
          }
          i.values['containsStr'].push({
            value: ''
          });
        }
      });
    },
    deletePostcodeFn(index) {
      this.postcodeArr.splice(index, 1);
    },
    showShippingDataApi(val) {
      let v = this;
      v.axios.get(api.get_enableCarriers + '?isFilter=true').then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          let pos = [];
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              pos.push({
                value: data[i].carrierId,
                label: data[i].carrierName,
                children: [],
                loading: false,
                carrierAccounts: data[i].carrierAccounts,
                apiInterface: data[i].apiInterface
              });
              if (i === data.length - 1) {
                v.shippingMethodData = pos;
              }
            }
          }
        } else {
          v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000192'));
        }
      });
    },
    getCommonCountry(list, selectArr) { // 国家 树
      let v = this;
      return new Promise(resolve => {
        if (list.length > 0) {
          makeTree(list);
        } else {
          getRegionalRcountriesData().then((data) => {
            makeTree(data);
          });
        }
        
        function makeTree(data) {
          if (!selectArr) selectArr = [];
          let arr = [
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'),
              check: false,
              expand: true,
              children: [],
              zoneCode: 'null'
            }
          ];
          data.forEach((n, i) => {
            let checked = false;
            selectArr.forEach((k, g) => {
              if (k === n.zoneCode) {
                checked = true;
              }
            });
            let obj = {
              title: n.zoneCnName,
              expand: false,
              checked: checked,
              zoneCode: n.zoneCode,
              children: []
            };
            if (n.countries.length > 1) {
              n.countries.forEach((m, t) => {
                let checked = false;
                selectArr.forEach((k, g) => {
                  if (k.indexOf('.') > 0) {
                    if (m.hasOwnProperty('twoCode') && k.split('.')[1] === m.twoCode) {
                      checked = true;
                    }
                  }
                });
                let subObj = {
                  title: m.cnName,
                  expand: false,
                  checked: checked,
                  zoneCode: n.zoneCode + '.' + m.twoCode,
                  children: []
                };
                obj.children.push(subObj);
              });
            } else if (n.countries.length === 1) {
              n.countries.forEach(i => {
                selectArr.forEach(j => {
                  if (i.zoneCode + '.' + i.zoneCode === j.value) {
                    obj.checked = true;
                  }
                });
              });
              obj.zoneCode = n.zoneCode + '.' + n.countries[0].twoCode;
            }
            arr[0].children.push(obj);
          });
          v.$nextTick(function () {
            resolve(arr);
          });
        }
      });
    },
    getCommonCountryName(list, selectArr) { // 获取对应国家名字
      let v = this;
      if (!selectArr || selectArr.length === 0) return false;
      makeTreeName(list);
      
      function makeTreeName(data) {
        let arr = [];
        data.forEach((n, i) => {
          selectArr.forEach((k, g) => {
            if (k.indexOf('.') > 0) {
              if (n.zoneCode === k.split('.')[0]) {
                if (n.countries && n.countries.length > 0) {
                  n.countries.forEach((g, l) => {
                    if (k.split('.')[1] === g.twoCode) {
                      arr.push(g.cnName);
                    }
                  });
                }
              }
            } else {
              if (k === n.zoneCode) {
                arr.push(n.zoneCnName);
              }
            }
          });
        });
        v.countryCodesName = arr.toString();
      }
    },
    getCloudSalesClassification(type = 'tile') {
      let ymsSiteId = null;
      let url = null;
      if (this.system === 'yms') {
        url = api.post_ymsProductCategory_queryAll;
      } else {
        url = api.post_ymsProductCategory_api_queryAll;
      }
      getYmsSiteData().then((data) => {
        if (data.length > 0) {
          let list = data.filter((item) => {
            return item.merchantType === 'YMS';
          });
          ymsSiteId = list[0].ymsSiteId;
          getCloudTreeData(url, type, null, ymsSiteId, {time: new Date().getTime()}).then((data) => {
            this.ymsProductCategoryList = data;
          });
        }
      });
    },
    setSiteIdName() {
      let ids = [];
      if (this.rules) {
        this.rules.forEach(i => {
          if (['DISTRIBUTOR-DCCR-A001', 'DISTRIBUTOR-DWCR-A001'].includes(i.id)) {
            ids = i.values['siteIds'];
          }
        });
        let str = ids && ids.length ? this.disSites.filter(i => {
          return ids.includes(i.siteId);
        }).map(i => i.cnName).join(' ') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000186');
        return str !== ' ' ? str : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000186');
      } else {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000186');
      }
    },
    setSaleAccountName() {
      let ids = [];
      if (this.rules) {
        this.rules.forEach(i => {
          if (['DISTRIBUTOR-DCCR-A001', 'DISTRIBUTOR-DWCR-A001'].includes(i.id)) {
            ids = i.values['saleAccountIds'];
          }
        });
        let str = ids && ids.length ? this.platformAccountList.filter(i => {
          return ids.includes(i.ymsPlatformAccountId);
        }).map(i => i.name).join(' ') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000187');
        return str !== ' ' ? str : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000187');
      } else {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000187');
      }
    },
    
    /**
     * @description 通用文本拼接函数，用于数组或字符串的格式化输出
     * @param {any} value - 要处理的值（可以是数组、字符串、数字等）
     * @param {Object} [options={}] - 可选配置
     * @param {Array<string>} [options.separators=[',', '，', '\n']] - 分隔符集合
     * @param {string} [options.joinSymbol='、'] - 拼接符号
     * @param {string} [options.emptyText='指定内容'] - 当值为空时显示的文本
     * @param {Function} [options.formatItem] - 每个元素的自定义格式化方法
     */
    formatListValue(
        value,
        {
          separators = [',', '，', '\n'],
          joinSymbol = '、',
          emptyText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000200'),
          formatItem = v => v, // 默认不处理
        } = {}
    ) {
      if (!value || (Array.isArray(value) && value.length === 0)) {
        return emptyText;
      }
      let arr = [];
      
      // 数组处理
      if (Array.isArray(value)) {
        arr = this.sepCommasFn(value.join(), separators);
      }
      // 字符串处理
      else if (typeof value === 'string') {
        arr = this.sepCommasFn(value, separators);
      }
      // 其他类型直接转字符串
      else {
        arr = [String(value)];
      }
      return arr.map(formatItem).join(joinSymbol);
    }
  },
  watch: {
    'amountRange.usdFloor'(n, o) {
      let v = this;
      if (n > v.amountRange.usdUpper) {
        v.amountRange.usdUpper = n;
      }
    },
    'amountRange.audFloor'(n, o) {
      let v = this;
      if (n > v.amountRange.audUpper) {
        v.amountRange.audUpper = n;
      }
    },
    'amountRange.eurFloor'(n, o) {
      let v = this;
      if (n > v.amountRange.eurUpper) {
        v.amountRange.eurUpper = n;
      }
    },
    'amountRange.gbpFloor'(n, o) {
      let v = this;
      if (n > v.amountRange.gbpUpper) {
        v.amountRange.gbpUpper = n;
      }
    },
    'amountRange.cnyFloor'(n, o) {
      let v = this;
      if (n > v.amountRange.cnyUpper) {
        v.amountRange.cnyUpper = n;
      }
    }
  },
  computed: {
    yunWarehouseName() {
      let ids = [];
      if (this.rules) {
        this.rules.forEach(i => {
          if (i.id === 'CORE-YPDR-011') {
            if (i.values['shippingMethodIds']) {
              ids = i.values['shippingMethodIds'];
            }
          }
        });
        return ids.length ? this.yunShipList.filter(i => {
          return ids.includes(i.ymsLogisServiceId);
        }).map(i => i.name).join(' ') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000201');
      } else {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000201');
      }
    }
  }
};